import Notifications from 'react-notify-toast';
import React from 'react';
import {Grid, Header} from 'semantic-ui-react';

import SaleForm from './SaleForm';
import SaleList from './SaleList'


export default class Sale extends React.Component {
    render() {
        return (<Grid.Row>
            <Header as='h1'>Cadastro de Vendas</Header>
            <Notifications />
            <Grid.Column>
                <SaleForm />
            </Grid.Column>
            <Grid.Column>
                <SaleList />
            </Grid.Column>
        </Grid.Row>)
    }
}